import { render, staticRenderFns } from "./ModifyLayout.vue?vue&type=template&id=495a0f04&scoped=true"
import script from "./ModifyLayout.vue?vue&type=script&lang=js"
export * from "./ModifyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a0f04",
  null
  
)

export default component.exports